import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function HistoricoInfo({
  historicos,
  label,
  showHist,
  isConsultaNova,
}: {
  historicos: any;
  label: string;
  showHist: boolean;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  const isEmail = label.toLowerCase().includes('email') || label.toLowerCase().includes('e-mail');
  const isPhone = label.toLowerCase().includes('fone') || label.toLowerCase().includes('tel') || label.toLowerCase().includes('celular');
  const icon = isEmail ? 'pi pi-envelope' : isPhone ? 'pi pi-phone' : 'pi pi-history';

  if (isConsultaNova) {
    const title = (showHist ? t('historico') + ' ' : '') + label;
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: '#EFF6FF',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className={icon} style={{ color: '#2563EB', fontSize: '18px' }}></i>
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>{title}</h3>
            <span style={{ fontSize: 'small', color: '#6B7280' }}>
              {historicos?.length || 0} registro{historicos?.length !== 1 ? 's' : ''} encontrado{historicos?.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {historicos && historicos.map((item: any, idx: number) => (
            <div
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                backgroundColor: idx === 0 ? '#F0F9FF' : '#F9FAFB',
                borderRadius: '10px',
                border: idx === 0 ? '1px solid #BAE6FD' : '1px solid #F3F4F6',
                gap: '12px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <i
                  className={icon}
                  style={{ color: idx === 0 ? '#0369A1' : '#9CA3AF', fontSize: '14px' }}
                />
                <span
                  style={{
                    fontWeight: idx === 0 ? 700 : 500,
                    color: idx === 0 ? '#1E40AF' : '#374151',
                    fontSize: 'small',
                  }}
                >
                  {item.historico}
                </span>
                {idx === 0 && (
                  <span
                    style={{
                      backgroundColor: '#DBEAFE',
                      color: '#1D4ED8',
                      fontSize: '0.7rem',
                      fontWeight: 700,
                      padding: '1px 6px',
                      borderRadius: '4px',
                    }}
                  >
                    ATUAL
                  </span>
                )}
              </div>
              {item.data && (
                <span
                  style={{
                    backgroundColor: '#F3F4F6',
                    color: '#6B7280',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    padding: '3px 8px',
                    borderRadius: '6px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.data}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <Panel header={(showHist ? t('historico') : '') + ' ' + label}>
      <DataTable size="small" value={historicos} tableStyle={{ minWidth: '50rem' }}>
        <Column field="historico" header={label}></Column>
        <Column field="data" header={t('data')}></Column>
      </DataTable>
    </Panel>
  );
}
